export const SET_NEWS_INFO = 'SET_NEWS_INFO';
export const SET_USER_NAME = 'SET_USER_NAME';
export const SET_SHOW = 'SET_SHOW';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_USERDATA = 'SET_USERDATA';
export const SET_GAME = 'SET_GAME';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js